import React from "react";

const StatCard = ({ icon, color, title, data, compact = false }) => {
  const cardContent = (
    <div
      className={`widget-stat card h-full transition-all duration-200 ${
        compact
          ? "shadow-[0_1px_2px_rgba(0,0,0,0.04)] border border-slate-200/90 bg-white rounded-3xl hover:shadow-[0_2px_8px_rgba(0,0,0,0.06)] hover:border-slate-300/80"
          : ""
      }`}
    >
      <div className={`p-1 card-body`}>
        <div className="media ai-icon">
          <span
            className={`bgl-${color} text-${color} flex items-center justify-center -mr-2 rounded-xl py-1 ${
              compact ? "w-8 h-8" : ""
            }`}
          >
            {icon}
          </span>
          <div className="space-y-2 min-w-0 media-body">
            <div
              className={`text-slate-500 truncate ${
                compact
                  ? "mb-1 text-sm font-normal tracking-wider capitalize"
                  : "mb-1"
              }`}
            >
              {title}
            </div>
            <h4
              className={`mb-0 font-semibold text-slate-800 ${
                compact ? "text-sm font-normal" : ""
              }`}
            >
              {data}
            </h4>
          </div>
        </div>
      </div>
    </div>
  );

  if (compact) {
    return <div key={title}>{cardContent}</div>;
  }

  return (
    <div className="col-xl-3 col-xxl-3 col-lg-6 col-sm-6" key={title}>
      {cardContent}
    </div>
  );
};

export default StatCard;
